// extracted by mini-css-extract-plugin
module.exports = {"form":"FormModal_form__NK5Ba","container":"FormModal_container__3S8EQ"};